// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Research Dashboard Styles */
/* Editorial Data Visualization Aesthetic */

.research-dashboard {
  padding: 24px 32px;
  animation: dashboardFadeIn 0.4s ease-out;
}

/* Loading State */
.dashboard-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 16px;
}

.dashboard-loading .loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255, 107, 74, 0.2);
  border-top-color: #FF6B4A;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.dashboard-loading p {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  color: var(--text-secondary);
}

/* Error State */
.dashboard-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  gap: 16px;
  text-align: center;
  padding: 40px;
  background: rgba(245, 158, 11, 0.08);
  border-radius: 16px;
  margin-top: 24px;
}

.dashboard-error svg {
  width: 48px;
  height: 48px;
  color: #d97706;
}

.dashboard-error p {
  font-family: 'DM Sans', sans-serif;
  font-size: 15px;
  color: var(--text-secondary);
  max-width: 400px;
}

@keyframes dashboardFadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Header */
.dashboard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.dashboard-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.dashboard-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  letter-spacing: -0.02em;
}

.dashboard-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-radius: 20px;
}

.dashboard-status.status-active {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.15) 0%, rgba(5, 150, 105, 0.1) 100%);
  color: #059669;
}

.dashboard-status.status-paused {
  background: rgba(245, 158, 11, 0.12);
  color: #d97706;
}

.dashboard-status.status-completed {
  background: rgba(59, 130, 246, 0.12);
  color: #2563eb;
}

.status-pulse {
  width: 8px;
  height: 8px;
  background: #10b981;
  border-radius: 50%;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.15);
  }
}

.dashboard-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Dashboard Buttons */
.dashboard-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dashboard-btn svg {
  width: 16px;
  height: 16px;
}

.dashboard-btn-primary {
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);
  color: white;
  box-shadow: 0 4px 14px rgba(255, 107, 74, 0.3);
}

.dashboard-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(255, 107, 74, 0.4);
}

.dashboard-btn-warning {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  box-shadow: 0 4px 14px rgba(245, 158, 11, 0.3);
}

.dashboard-btn-warning:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.4);
}

.dashboard-btn-success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.3);
}

.dashboard-btn-success:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
}

.dashboard-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none !important;
}

.dashboard-btn .btn-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.dropdown-arrow {
  width: 14px;
  height: 14px;
  margin-left: 2px;
  transition: transform 0.2s ease;
}

/* Export Dropdown */
.export-dropdown {
  position: relative;
}

.export-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  min-width: 180px;
  z-index: 100;
  animation: dropdownSlide 0.2s ease-out;
}

@keyframes dropdownSlide {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.export-menu button {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 14px 18px;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  background: none;
  border: none;
  cursor: pointer;
  transition: background 0.15s ease;
}

.export-menu button:hover {
  background: rgba(0, 0, 0, 0.04);
}

.export-menu button svg {
  width: 18px;
  height: 18px;
  color: var(--text-secondary);
}

.export-menu-divider {
  height: 1px;
  background: rgba(0, 0, 0, 0.08);
  margin: 4px 0;
}

/* Progress Section */
.dashboard-progress-section {
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.04) 0%, rgba(142, 58, 154, 0.04) 100%);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 32px;
}

.progress-info {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 16px;
}

.progress-numbers {
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.progress-current {
  font-family: 'DM Sans', sans-serif;
  font-size: 32px;
  font-weight: 700;
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.progress-separator {
  font-size: 24px;
  color: var(--text-tertiary);
  font-weight: 300;
}

.progress-target {
  font-family: 'DM Sans', sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: var(--text-secondary);
}

.progress-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  color: var(--text-tertiary);
  margin-left: 8px;
}

.progress-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.progress-warmup {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.12) 0%, rgba(217, 119, 6, 0.08) 100%);
  color: #d97706;
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
  font-weight: 600;
  border-radius: 16px;
  animation: warmupPulse 2s ease-in-out infinite;
}

.progress-warmup svg {
  width: 14px;
  height: 14px;
}

@keyframes warmupPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

.progress-duration {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  color: var(--text-tertiary);
}

.progress-percentage {
  font-family: 'DM Sans', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-secondary);
}

.progress-bar-container {
  height: 10px;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);
  border-radius: 5px;
  transition: width 0.8s ease-out;
  position: relative;
}

.progress-bar-fill.animate::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.3) 50%,
    transparent 100%
  );
  animation: shimmer 2s ease-in-out infinite;
}

.progress-bar-fill.warmup {
  background: linear-gradient(90deg, #f59e0b 0%, #d97706 100%);
  width: 2% !important;
  animation: warmupBar 1.5s ease-in-out infinite;
}

@keyframes warmupBar {
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
}

.progress-estimate {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 12px 16px;
  background: rgba(59, 130, 246, 0.08);
  border-radius: 10px;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  color: var(--text-secondary);
}

.progress-estimate svg {
  width: 18px;
  height: 18px;
  color: #3b82f6;
  flex-shrink: 0;
}

.progress-estimate strong {
  color: #2563eb;
  font-weight: 600;
}

.progress-complete {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 12px 16px;
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.08) 100%);
  border-radius: 10px;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #059669;
}

.progress-complete svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.progress-complete-dates {
  font-weight: 400;
  opacity: 0.8;
}

/* Warmup placeholder */
.warmup-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 40px;
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.06) 0%, rgba(217, 119, 6, 0.04) 100%);
  border-radius: 16px;
  text-align: center;
}

.warmup-placeholder-icon {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.15) 0%, rgba(217, 119, 6, 0.1) 100%);
  border-radius: 50%;
  margin-bottom: 20px;
  animation: warmupIconPulse 2s ease-in-out infinite;
}

.warmup-placeholder-icon svg {
  width: 32px;
  height: 32px;
  color: #d97706;
}

@keyframes warmupIconPulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.05); opacity: 0.8; }
}

.warmup-placeholder h4 {
  font-family: 'DM Sans', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 8px 0;
}

.warmup-placeholder p {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0;
  max-width: 400px;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

/* Section Styles */
.dashboard-section {
  margin-bottom: 32px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: 'DM Sans', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 20px 0;
}

.section-title svg {
  width: 20px;
  height: 20px;
  color: var(--accent-orange);
}

/* Demographics Grid */
.demographics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

/* Donut Chart */
.donut-chart-container {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.donut-chart-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-secondary);
  margin: 0 0 20px 0;
  text-align: center;
}

.donut-chart-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
  position: relative;
}

.donut-chart-wrapper svg {
  overflow: visible;
}

.donut-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
  font-weight: 600;
  fill: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  pointer-events: none;
}

.donut-segment.hovered {
  opacity: 0.85;
  filter: brightness(1.1);
}

.donut-tooltip {
  position: absolute;
  background: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 10px 14px;
  border-radius: 8px;
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  pointer-events: none;
  transform: translate(-50%, -100%);
  z-index: 100;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.donut-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: rgba(0, 0, 0, 0.9);
}

.donut-tooltip-label {
  font-weight: 600;
  margin-bottom: 4px;
}

.donut-tooltip-value {
  color: rgba(255, 255, 255, 0.9);
}

.donut-tooltip-percent {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}

.donut-segment {
  animation: donutFadeIn 0.5s ease-out forwards;
  opacity: 0;
  transition: opacity 0.2s ease, filter 0.2s ease;
  cursor: pointer;
}

@keyframes donutFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.donut-legend {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-end;
}

.donut-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
}

.donut-legend-color {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  flex-shrink: 0;
}

.donut-legend-label {
  color: var(--text-secondary);
  min-width: 50px;
}

.donut-legend-value {
  font-weight: 600;
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
  min-width: 55px;
  text-align: right;
}

/* Total Respondents Card */
.total-respondents-card {
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);
  border-radius: 16px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
}

.total-number {
  font-family: 'DM Sans', sans-serif;
  font-size: 48px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 8px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}

.total-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.9;
  margin-bottom: 12px;
}

.total-target {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  opacity: 0.75;
  background: rgba(255, 255, 255, 0.2);
  padding: 6px 14px;
  border-radius: 20px;
}

/* Questions Results */
.questions-results {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.question-result-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.04);
  overflow: visible;
  transition: all 0.25s ease;
}

.question-result-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.question-result-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.question-result-header:hover {
  background: rgba(0, 0, 0, 0.02);
}

.question-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);
  color: white;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  border-radius: 10px;
  flex-shrink: 0;
}

.question-text {
  flex: 1 1;
  font-family: 'DM Sans', sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: var(--text-primary);
  line-height: 1.5;
}

.expand-icon {
  width: 20px;
  height: 20px;
  color: var(--text-tertiary);
  transition: transform 0.25s ease;
  flex-shrink: 0;
}

.question-result-card.expanded .expand-icon {
  transform: rotate(180deg);
}

.question-result-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.35s ease;
}

.question-result-card.expanded .question-result-content {
  max-height: none;
  overflow: visible;
}

.question-charts-row {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 32px;
  padding: 0 24px 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  padding-top: 24px;
  overflow: visible;
}

@media (max-width: 1400px) {
  .question-charts-row {
    grid-template-columns: 200px 1fr;
    gap: 16px;
  }

  .stacked-bars {
    gap: 3px;
  }

  .stacked-bar-label {
    font-size: 8px;
  }
}

@media (max-width: 1100px) {
  .question-charts-row {
    grid-template-columns: 180px 1fr;
    gap: 12px;
  }

  .question-pie-wrapper svg {
    width: 160px;
    height: 160px;
  }

  .stacked-bars {
    gap: 2px;
  }

  .stacked-bar-label {
    font-size: 7px;
  }
}

@media (max-width: 950px) {
  .question-charts-row {
    grid-template-columns: 160px 1fr;
    gap: 10px;
  }

  .question-pie-wrapper svg {
    width: 140px;
    height: 140px;
  }
}

@media (max-width: 850px) {
  .question-charts-row {
    grid-template-columns: 1fr;
  }
}

/* Pie Chart Section */
.question-pie-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: visible;
}

.question-pie-section.multiple-choice-section {
  align-items: stretch;
}

/* When multiple-choice section is present, override grid to give more space */
.question-charts-row:has(.multiple-choice-section) {
  grid-template-columns: minmax(280px, 400px) 1fr;
}

.question-pie-wrapper {
  position: relative;
  margin-bottom: 16px;
}

.pie-chart {
  overflow: visible;
}

.pie-segment {
  animation: pieReveal 0.6s ease-out forwards;
  transform-origin: center;
  opacity: 0;
  transition: opacity 0.2s ease, filter 0.2s ease;
  cursor: pointer;
}

.pie-segment.hovered {
  opacity: 0.85;
  filter: brightness(1.1);
}

@keyframes pieReveal {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.pie-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 11px;
  font-weight: 600;
  fill: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  pointer-events: none;
}

.question-legend {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.question-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
}

.legend-color {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  flex-shrink: 0;
}

.legend-text {
  color: var(--text-secondary);
  flex: 1 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.legend-value {
  font-weight: 600;
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
  flex-shrink: 0;
  text-align: right;
}

/* Creative-test legend — dot + thumbnail + value, compact and left-aligned */
.question-legend.creative-legend {
  align-items: flex-start;
  gap: 10px;
}
.question-legend.creative-legend .question-legend-item {
  width: auto;
  gap: 12px;
}
.legend-thumb {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  object-fit: contain;
  border-radius: 7px;
  border: 1px solid var(--border-color, #e5e5ee);
  background: #fff;
  padding: 2px;
}

/* Thumbnail inside a chart tooltip (creative-test) — kept small */
.tooltip-thumb {
  display: block;
  width: 64px;
  height: 64px;
  object-fit: contain;
  border-radius: 6px;
  background: #fff;
  padding: 2px;
  margin: 4px auto;
}

/* Stacked Bar Chart */
.question-breakdown-section {
  min-width: 0;
  overflow: visible;
}

.breakdown-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  margin: 0 0 16px 0;
}

.stacked-bar-chart {
  display: flex;
  gap: 8px;
  position: relative;
  overflow: visible;
}

.stacked-bar-axis {
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  height: 180px;
  padding-right: 8px;
  flex-shrink: 0;
}

.stacked-bar-axis span {
  font-family: 'DM Sans', sans-serif;
  font-size: 10px;
  color: var(--text-tertiary);
  text-align: right;
}

.stacked-bars {
  display: flex;
  gap: 6px;
  flex: 1 1;
  min-width: 0;
  align-items: flex-end;
  justify-content: space-evenly;
}

.stacked-bar-column {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stacked-bar {
  width: 100%;
  max-width: 70px;
  height: 180px;
  display: flex;
  flex-direction: column-reverse;
  border-radius: 6px 6px 0 0;
  overflow: hidden;
  background: #f1f3f4;
}

.stacked-bar-segment {
  width: 100%;
  transition: all 0.3s ease;
  animation: barGrow 0.5s ease-out forwards;
  transform-origin: bottom;
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.stacked-bar-value {
  font-family: 'DM Sans', sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  line-height: 1;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
  pointer-events: none;
}

@keyframes barGrow {
  from {
    transform: scaleY(0);
    opacity: 0;
  }
  to {
    transform: scaleY(1);
    opacity: 1;
  }
}

.stacked-bar-segment:hover,
.stacked-bar-segment.hovered {
  filter: brightness(1.15);
  cursor: pointer;
}

.stacked-bar-tooltip {
  position: absolute;
  background: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 10px 14px;
  border-radius: 8px;
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
  pointer-events: none;
  transform: translate(-50%, -100%);
  z-index: 100;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.stacked-bar-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: rgba(0, 0, 0, 0.9);
}

.stacked-bar-tooltip-group {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 2px;
}

.stacked-bar-tooltip-answer {
  font-weight: 600;
  margin-bottom: 2px;
}

.stacked-bar-tooltip-percent {
  color: rgba(255, 255, 255, 0.8);
}

.stacked-bar-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 9px;
  font-weight: 500;
  color: var(--text-tertiary);
  margin-top: 8px;
  white-space: nowrap;
  transform: rotate(-45deg);
  transform-origin: center center;
  height: 40px;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .dashboard-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .dashboard-header-right {
    width: 100%;
    justify-content: flex-start;
  }

  .dashboard-title {
    font-size: 20px;
  }

  .progress-current {
    font-size: 24px;
  }

  .progress-target {
    font-size: 18px;
  }

  .total-number {
    font-size: 36px;
  }

  .stacked-bar-label {
    font-size: 8px;
  }
}

/* Horizontal Bar Chart for Multiple Choice */
.horizontal-bar-chart {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 0;
}

.horizontal-bar-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.horizontal-bar-label {
  flex: 0 0 120px;
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: right;
}

.multiple-choice-section .horizontal-bar-label {
  flex: 0 0 140px;
}

.horizontal-bar-track {
  flex: 1 1;
  height: 28px;
  min-width: 80px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 6px;
  overflow: hidden;
}

.horizontal-bar-fill {
  height: 100%;
  border-radius: 6px;
  transition: width 0.3s ease, opacity 0.2s ease;
  cursor: pointer;
}

.horizontal-bar-fill {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 6px;
  min-width: fit-content;
}

.horizontal-bar-fill:hover,
.horizontal-bar-fill.hovered {
  opacity: 0.85;
}

.horizontal-bar-value-inside {
  font-family: 'DM Mono', monospace;
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(0,0,0,0.3);
}

.horizontal-bar-value {
  display: none;
  flex: 0 0 50px;
  font-family: 'DM Mono', monospace;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-primary);
  text-align: right;
}

.horizontal-bar-tooltip {
  position: absolute;
  background: rgba(30, 30, 35, 0.95);
  backdrop-filter: blur(8px);
  padding: 10px 14px;
  border-radius: 8px;
  pointer-events: none;
  transform: translate(-50%, -100%);
  z-index: 100;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  min-width: 140px;
}

.horizontal-bar-tooltip-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
}

.horizontal-bar-tooltip-value {
  font-family: 'DM Sans', sans-serif;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.7);
}

.horizontal-bar-tooltip-percent {
  font-family: 'DM Mono', monospace;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin-top: 4px;
}

.multiple-choice-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: var(--text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  padding: 4px 8px;
  background: rgba(142, 58, 154, 0.1);
  border-radius: 4px;
  display: inline-block;
}

/* Progress Dates (Start + End) */
.progress-dates {
  display: flex;
  gap: 24px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.progress-date-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  color: var(--text-secondary);
}

.progress-date-item svg {
  width: 16px;
  height: 16px;
  stroke: var(--text-tertiary);
  flex-shrink: 0;
}

.progress-date-item strong {
  color: var(--text-primary);
  font-weight: 600;
}

/* ===== AI Analysis Button & Panel ===== */

.dashboard-btn-ai {
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);
  color: #fff;
  border: none;
  position: relative;
  overflow: hidden;
}
.dashboard-btn-ai svg {
  width: 16px; height: 16px;
}
.dashboard-btn-ai:hover {
  filter: brightness(1.08);
  box-shadow: 0 4px 14px rgba(233, 75, 108, 0.35);
}
.dashboard-btn-ai::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(120deg, transparent 30%, rgba(255,255,255,0.18) 50%, transparent 70%);
  transform: translateX(-100%);
  transition: transform 0.7s ease;
}
.dashboard-btn-ai:hover::before { transform: translateX(100%); }

.ai-panel-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 15, 20, 0.55);
  backdrop-filter: blur(4px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: aiOverlayIn 180ms ease;
}
@keyframes aiOverlayIn { from { opacity: 0; } to { opacity: 1; } }

.ai-panel {
  background: #fff;
  border-radius: 16px;
  width: min(880px, 92vw);
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.28);
  overflow: hidden;
  animation: aiPanelIn 240ms cubic-bezier(0.2, 0.7, 0.2, 1);
}
@keyframes aiPanelIn {
  from { transform: translateY(12px) scale(0.985); opacity: 0; }
  to   { transform: translateY(0) scale(1); opacity: 1; }
}

.ai-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  border-bottom: 1px solid #ECEDF2;
  background: linear-gradient(135deg, rgba(255,107,74,0.06) 0%, rgba(142,58,154,0.06) 100%);
}
.ai-panel-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: 'DM Sans', sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: var(--text-primary);
}
.ai-panel-title svg {
  width: 22px; height: 22px;
  stroke: url(#ai-grad-stub) #E94B6C;
}
.ai-panel-header-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}
.ai-panel-lang-switch {
  display: inline-flex;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  padding: 3px;
  margin-right: 4px;
}
.ai-panel-lang-btn {
  border: none;
  background: transparent;
  padding: 5px 10px;
  font-family: 'DM Sans', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: var(--text-secondary);
  cursor: pointer;
  border-radius: 6px;
  min-width: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}
.ai-panel-lang-btn:hover:not(:disabled) { color: var(--text-primary); background: rgba(0,0,0,0.04); }
.ai-panel-lang-btn.active {
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 60%, #8E3A9A 100%);
  color: #fff;
  box-shadow: 0 2px 8px rgba(233, 75, 108, 0.25);
}
.ai-panel-lang-btn:disabled { opacity: 0.6; cursor: wait; }
.ai-panel-icon-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
}
.ai-panel-icon-btn:hover:not(:disabled) { background: rgba(0,0,0,0.05); color: var(--text-primary); }
.ai-panel-icon-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.ai-panel-icon-btn svg { width: 18px; height: 18px; }
.btn-spinner-sm {
  display: inline-block;
  width: 12px; height: 12px;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: aiSpin 0.7s linear infinite;
}
@keyframes aiSpin { to { transform: rotate(360deg); } }

.ai-panel-tabs {
  position: relative;
  display: flex;
  align-items: stretch;
  gap: 4px;
  padding: 0 24px;
  flex: 0 0 auto;
  min-height: 52px;
  border-bottom: 1px solid #ECEDF2;
  overflow: visible;
  flex-wrap: wrap;
}
.ai-panel-tab {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0 14px;
  margin: 4px 0;
  border: none;
  outline: none;
  background: transparent;
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  position: relative;
  transition: color 0.15s, background 0.15s;
  white-space: nowrap;
  line-height: 1;
  border-radius: 8px;
}
.ai-panel-tab:focus-visible {
  box-shadow: 0 0 0 2px rgba(233, 75, 108, 0.3);
}
.ai-panel-tab:hover {
  color: var(--text-primary);
  background: rgba(0, 0, 0, 0.03);
}
.ai-panel-tab.active {
  color: #fff;
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 60%, #8E3A9A 100%);
}
.ai-panel-tab.active:hover { color: #fff; filter: brightness(1.05); }
.ai-panel-tab-trend.active {
  background: linear-gradient(135deg, #E94B6C 0%, #8E3A9A 100%);
}

.ai-panel-content {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;
}
.ai-panel-loading,
.ai-panel-empty {
  padding: 48px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: var(--text-secondary);
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
}
.ai-panel-q-context {
  font-size: 13px;
  font-style: italic;
  color: var(--text-tertiary);
  margin: 0 0 16px 0;
  padding: 10px 14px;
  border-left: 3px solid #FF6B4A;
  background: rgba(255, 107, 74, 0.04);
  border-radius: 0 6px 6px 0;
}
.ai-panel-footer {
  margin-top: 24px;
  padding-top: 12px;
  border-top: 1px solid #ECEDF2;
  font-size: 11px;
  color: var(--text-tertiary);
  font-family: 'DM Sans', sans-serif;
}

/* Markdown rendering */
.ai-md { font-family: 'DM Sans', sans-serif; color: var(--text-primary); line-height: 1.6; font-size: 14px; }
.ai-md-h2 { font-size: 20px; font-weight: 700; margin: 0 0 12px 0; color: var(--text-primary); }
.ai-md-h3 { font-size: 16px; font-weight: 700; margin: 18px 0 8px 0; color: var(--text-primary); }
.ai-md-h4 { font-size: 14px; font-weight: 700; margin: 14px 0 6px 0; color: var(--text-secondary); text-transform: uppercase; letter-spacing: 0.4px; }
.ai-md-p { margin: 0 0 12px 0; }
.ai-md-list { margin: 0 0 12px 0; padding-left: 22px; }
.ai-md-list li { margin-bottom: 6px; }
.ai-md-hr { border: 0; border-top: 1px solid #ECEDF2; margin: 16px 0; }
.ai-md code { background: rgba(142, 58, 154, 0.08); color: #8E3A9A; padding: 1px 5px; border-radius: 4px; font-size: 0.9em; font-family: 'JetBrains Mono', monospace; }
.ai-md strong { color: var(--text-primary); font-weight: 700; }
.ai-md-table { border-collapse: collapse; width: 100%; margin: 12px 0; font-size: 13px; }
.ai-md-table th, .ai-md-table td { text-align: left; padding: 8px 12px; border-bottom: 1px solid #ECEDF2; }
.ai-md-table th { background: #F7F8FB; font-weight: 600; color: var(--text-secondary); }
.ai-md-table tr:last-child td { border-bottom: none; }
.ai-md-olist { padding-left: 26px; }
.ai-md-olist li { padding-left: 4px; }

/* Print-only blocks rendered inside the modal — flat document of all sections */
.ai-print-only { display: none; }
.ai-print-section { margin-bottom: 32px; page-break-inside: avoid; }
.ai-print-section h3.ai-print-section-title {
  font-size: 13px; text-transform: uppercase; letter-spacing: 1px;
  color: #888; margin: 0 0 4px 0; font-weight: 600;
}
.ai-print-section h2.ai-print-section-name {
  font-size: 18px; margin: 0 0 12px 0; font-weight: 700;
}

@media print {
  /* Hide everything at the body root except the AI panel overlay (rendered via portal) */
  body > *:not(.ai-panel-overlay) { display: none !important; }
  /* Strip the modal chrome — render as plain document flow */
  .ai-panel-overlay {
    position: static !important;
    background: transparent !important;
    backdrop-filter: none !important;
    inset: auto !important;
    display: block !important;
    animation: none !important;
    height: auto !important;
    width: 100% !important;
  }
  .ai-panel {
    box-shadow: none !important;
    border-radius: 0 !important;
    max-height: none !important;
    width: 100% !important;
    overflow: visible !important;
    animation: none !important;
    display: block !important;
  }
  .ai-panel-header-actions, .ai-panel-tabs, .ai-panel-footer,
  .ai-panel-loading, .ai-panel-empty { display: none !important; }
  .ai-panel-content { overflow: visible !important; padding: 0 !important; display: block !important; }
  .ai-panel-header {
    background: transparent !important;
    border-bottom: 2px solid #000 !important;
    padding: 0 0 12px 0 !important;
    margin-bottom: 24px !important;
    display: flex !important;
  }
  .ai-print-only { display: block !important; }
  .ai-print-active-only { display: none !important; }
  .ai-md, .ai-md p, .ai-md li { font-size: 11pt !important; line-height: 1.45 !important; color: #000 !important; }
  .ai-md-h2 { font-size: 16pt !important; margin-top: 18px !important; }
  .ai-md-h3 { font-size: 13pt !important; margin-top: 14px !important; }
  .ai-md-h4 { font-size: 11pt !important; }
  .ai-md-table { font-size: 10pt !important; }
  .ai-panel-q-context { background: #f6f6f6 !important; color: #333 !important; }
  @page { margin: 18mm 16mm; }
}

/* ---------------------------------------------------------------------------
   Audience settings — the brief the research was ordered with, sitting between
   the progress bar and the demographics that actually answered. Collapsed by
   default so it never competes with the results.
   --------------------------------------------------------------------------- */
.audience-brief {
  background: #fff;
  border: 1px solid #edeff2;
  border-radius: 14px;
  margin-bottom: 24px;
  overflow: hidden;
}

.audience-brief-header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}

.audience-brief-header:hover { background: #fafbfc; }

.audience-brief-header > svg:first-child {
  width: 18px;
  height: 18px;
  color: var(--text-tertiary, #9aa0a6);
  flex-shrink: 0;
}

.audience-brief-title {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  flex-shrink: 0;
}

/* The one-line recap keeps the collapsed state informative. */
.audience-brief-summary {
  font-size: 13px;
  color: #6c757d;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.audience-brief-chevron {
  width: 18px;
  height: 18px;
  color: #9aa0a6;
  flex-shrink: 0;
  transition: transform 0.25s ease;
}

.audience-brief.expanded .audience-brief-chevron { transform: rotate(180deg); }

.audience-brief-body {
  padding: 4px 20px 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  border-top: 1px solid #f1f3f5;
}

.audience-brief-row {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  gap: 14px;
  align-items: baseline;
}

@media (max-width: 720px) {
  .audience-brief-row { grid-template-columns: 1fr; gap: 6px; }
}

.audience-brief-label {
  font-size: 13px;
  color: #6c757d;
  padding-top: 4px;
}

.audience-brief-values {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.audience-brief-chip {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f4f6f8;
  color: #1a1a1a;
  font-size: 12.5px;
  line-height: 1.35;
}

/* The dashboard sits in a panel that can get narrow: a long research name
   is one unbreakable token, and the action row must wrap rather than
   widen the page. */
.research-dashboard { min-width: 0; }
.dashboard-header { flex-wrap: wrap; gap: 12px; min-width: 0; }
.dashboard-header-left { min-width: 0; }
.dashboard-title { overflow-wrap: anywhere; min-width: 0; }
.dashboard-header-right { flex-wrap: wrap; }
`, "",{"version":3,"sources":["webpack://./src/styles/research-dashboard.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B,2CAA2C;;AAE3C;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,6FAA6F;EAC7F,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0EAA0E;EAC1E,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,+FAA+F;EAC/F,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,8FAA8F;EAC9F,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yEAAyE;EACzE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;GAKC;EACD,0CAA0C;AAC5C;;AAEA;EACE,4DAA4D;EAC5D,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,6FAA6F;EAC7F,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,8FAA8F;EAC9F,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6FAA6F;EAC7F,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW,mBAAmB,EAAE,UAAU,EAAE;EAC5C,MAAM,sBAAsB,EAAE,YAAY,EAAE;AAC9C;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,oBAAoB;EACpB,iCAAiC;EACjC,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,UAAU;EACV,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,0EAA0E;EAC1E,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,oBAAoB;EACpB,yCAAyC;EACzC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;IACE,gCAAgC;IAChC,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,8EAA8E;AAC9E;EACE,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,wBAAwB;EACxB,UAAU;EACV,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;EAClC,cAAc;EACd,iBAAiB;AACnB;;AAEA,6EAA6E;AAC7E;EACE,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;EAChB,YAAY;AACd;;AAEA,kEAAkE;AAClE;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yCAAyC;EACzC,wBAAwB;EACxB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE;IACE,oBAAoB;IACpB,UAAU;EACZ;EACA;IACE,oBAAoB;IACpB,UAAU;EACZ;AACF;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,oBAAoB;EACpB,iCAAiC;EACjC,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,iCAAiC;EACjC,YAAY;EACZ,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,2CAA2C;;AAE3C;EACE,0EAA0E;EAC1E,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW,EAAE,YAAY;AAC3B;AACA;EACE,wBAAwB;EACxB,+CAA+C;AACjD;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,iGAAiG;EACjG,4BAA4B;EAC5B,+BAA+B;AACjC;AACA,kCAAkC,2BAA2B,EAAE;;AAE/D;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;AACA,yBAAyB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAEjE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,gBAAgB;EAChB,yDAAyD;AAC3D;AACA;EACE,OAAO,wCAAwC,EAAE,UAAU,EAAE;EAC7D,OAAO,iCAAiC,EAAE,UAAU,EAAE;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,yFAAyF;AAC3F;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,WAAW,EAAE,YAAY;EACzB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;AACA,0CAA0C,0BAA0B,EAAE,4BAA4B,EAAE;AACpG;EACE,0EAA0E;EAC1E,WAAW;EACX,8CAA8C;AAChD;AACA,8BAA8B,YAAY,EAAE,YAAY,EAAE;AAC1D;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,0CAA0C,4BAA4B,EAAE,0BAA0B,EAAE;AACpG,8BAA8B,YAAY,EAAE,mBAAmB,EAAE;AACjE,yBAAyB,WAAW,EAAE,YAAY,EAAE;AACpD;EACE,qBAAqB;EACrB,WAAW,EAAE,YAAY;EACzB,uCAAuC;EACvC,sBAAsB;EACtB,kBAAkB;EAClB,sCAAsC;AACxC;AACA,oBAAoB,KAAK,yBAAyB,EAAE,EAAE;;AAEtD;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,0EAA0E;AAC5E;AACA,6BAA6B,WAAW,EAAE,wBAAwB,EAAE;AACpE;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;AACA;;EAEE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,4BAA4B;EAC5B,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,uBAAuB;AACvB,SAAS,kCAAkC,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC5G,YAAY,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AAC/F,YAAY,eAAe,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,0BAA0B,EAAE;AACjG,YAAY,eAAe,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,4BAA4B,EAAE,yBAAyB,EAAE,qBAAqB,EAAE;AACrJ,WAAW,kBAAkB,EAAE;AAC/B,cAAc,kBAAkB,EAAE,kBAAkB,EAAE;AACtD,iBAAiB,kBAAkB,EAAE;AACrC,YAAY,SAAS,EAAE,6BAA6B,EAAE,cAAc,EAAE;AACtE,cAAc,oCAAoC,EAAE,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,wCAAwC,EAAE;AACtK,gBAAgB,0BAA0B,EAAE,gBAAgB,EAAE;AAC9D,eAAe,yBAAyB,EAAE,WAAW,EAAE,cAAc,EAAE,eAAe,EAAE;AACxF,mCAAmC,gBAAgB,EAAE,iBAAiB,EAAE,gCAAgC,EAAE;AAC1G,kBAAkB,mBAAmB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AACvF,gCAAgC,mBAAmB,EAAE;AACrD,eAAe,kBAAkB,EAAE;AACnC,kBAAkB,iBAAiB,EAAE;;AAErC,gFAAgF;AAChF,iBAAiB,aAAa,EAAE;AAChC,oBAAoB,mBAAmB,EAAE,wBAAwB,EAAE;AACnE;EACE,eAAe,EAAE,yBAAyB,EAAE,mBAAmB;EAC/D,WAAW,EAAE,iBAAiB,EAAE,gBAAgB;AAClD;AACA;EACE,eAAe,EAAE,kBAAkB,EAAE,gBAAgB;AACvD;;AAEA;EACE,uFAAuF;EACvF,kCAAkC,wBAAwB,EAAE;EAC5D,2DAA2D;EAC3D;IACE,2BAA2B;IAC3B,kCAAkC;IAClC,gCAAgC;IAChC,sBAAsB;IACtB,yBAAyB;IACzB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;uCACqC,wBAAwB,EAAE;EAC/D,oBAAoB,4BAA4B,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;EACpG;IACE,kCAAkC;IAClC,wCAAwC;IACxC,8BAA8B;IAC9B,8BAA8B;IAC9B,wBAAwB;EAC1B;EACA,iBAAiB,yBAAyB,EAAE;EAC5C,wBAAwB,wBAAwB,EAAE;EAClD,8BAA8B,0BAA0B,EAAE,4BAA4B,EAAE,sBAAsB,EAAE;EAChH,YAAY,0BAA0B,EAAE,2BAA2B,EAAE;EACrE,YAAY,0BAA0B,EAAE,2BAA2B,EAAE;EACrE,YAAY,0BAA0B,EAAE;EACxC,eAAe,0BAA0B,EAAE;EAC3C,sBAAsB,8BAA8B,EAAE,sBAAsB,EAAE;EAC9E,QAAQ,iBAAiB,EAAE;AAC7B;;AAEA;;;;gFAIgF;AAChF;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,+BAA+B,mBAAmB,EAAE;;AAEpD;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,eAAe;EACf,cAAc;EACd,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gCAAgC;AAClC;;AAEA,mDAAmD,yBAAyB,EAAE;;AAE9E;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,sBAAsB,0BAA0B,EAAE,QAAQ,EAAE;AAC9D;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;oBAEoB;AACpB,sBAAsB,YAAY,EAAE;AACpC,oBAAoB,eAAe,EAAE,SAAS,EAAE,YAAY,EAAE;AAC9D,yBAAyB,YAAY,EAAE;AACvC,mBAAmB,uBAAuB,EAAE,YAAY,EAAE;AAC1D,0BAA0B,eAAe,EAAE","sourcesContent":["/* Research Dashboard Styles */\n/* Editorial Data Visualization Aesthetic */\n\n.research-dashboard {\n  padding: 24px 32px;\n  animation: dashboardFadeIn 0.4s ease-out;\n}\n\n/* Loading State */\n.dashboard-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: 16px;\n}\n\n.dashboard-loading .loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid rgba(255, 107, 74, 0.2);\n  border-top-color: #FF6B4A;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n.dashboard-loading p {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n/* Error State */\n.dashboard-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n  gap: 16px;\n  text-align: center;\n  padding: 40px;\n  background: rgba(245, 158, 11, 0.08);\n  border-radius: 16px;\n  margin-top: 24px;\n}\n\n.dashboard-error svg {\n  width: 48px;\n  height: 48px;\n  color: #d97706;\n}\n\n.dashboard-error p {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 15px;\n  color: var(--text-secondary);\n  max-width: 400px;\n}\n\n@keyframes dashboardFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Header */\n.dashboard-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.dashboard-header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.dashboard-title {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  letter-spacing: -0.02em;\n}\n\n.dashboard-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-radius: 20px;\n}\n\n.dashboard-status.status-active {\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.15) 0%, rgba(5, 150, 105, 0.1) 100%);\n  color: #059669;\n}\n\n.dashboard-status.status-paused {\n  background: rgba(245, 158, 11, 0.12);\n  color: #d97706;\n}\n\n.dashboard-status.status-completed {\n  background: rgba(59, 130, 246, 0.12);\n  color: #2563eb;\n}\n\n.status-pulse {\n  width: 8px;\n  height: 8px;\n  background: #10b981;\n  border-radius: 50%;\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.6;\n    transform: scale(1.15);\n  }\n}\n\n.dashboard-header-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Dashboard Buttons */\n.dashboard-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.dashboard-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.dashboard-btn-primary {\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);\n  color: white;\n  box-shadow: 0 4px 14px rgba(255, 107, 74, 0.3);\n}\n\n.dashboard-btn-primary:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(255, 107, 74, 0.4);\n}\n\n.dashboard-btn-warning {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n  box-shadow: 0 4px 14px rgba(245, 158, 11, 0.3);\n}\n\n.dashboard-btn-warning:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.4);\n}\n\n.dashboard-btn-success {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.3);\n}\n\n.dashboard-btn-success:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);\n}\n\n.dashboard-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n.dashboard-btn .btn-spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.dropdown-arrow {\n  width: 14px;\n  height: 14px;\n  margin-left: 2px;\n  transition: transform 0.2s ease;\n}\n\n/* Export Dropdown */\n.export-dropdown {\n  position: relative;\n}\n\n.export-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  min-width: 180px;\n  z-index: 100;\n  animation: dropdownSlide 0.2s ease-out;\n}\n\n@keyframes dropdownSlide {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.export-menu button {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 14px 18px;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.export-menu button:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.export-menu button svg {\n  width: 18px;\n  height: 18px;\n  color: var(--text-secondary);\n}\n\n.export-menu-divider {\n  height: 1px;\n  background: rgba(0, 0, 0, 0.08);\n  margin: 4px 0;\n}\n\n/* Progress Section */\n.dashboard-progress-section {\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.04) 0%, rgba(142, 58, 154, 0.04) 100%);\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 32px;\n}\n\n.progress-info {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.progress-numbers {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n}\n\n.progress-current {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 32px;\n  font-weight: 700;\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.progress-separator {\n  font-size: 24px;\n  color: var(--text-tertiary);\n  font-weight: 300;\n}\n\n.progress-target {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 24px;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n.progress-label {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 14px;\n  color: var(--text-tertiary);\n  margin-left: 8px;\n}\n\n.progress-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.progress-warmup {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: linear-gradient(135deg, rgba(245, 158, 11, 0.12) 0%, rgba(217, 119, 6, 0.08) 100%);\n  color: #d97706;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 16px;\n  animation: warmupPulse 2s ease-in-out infinite;\n}\n\n.progress-warmup svg {\n  width: 14px;\n  height: 14px;\n}\n\n@keyframes warmupPulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.7; }\n}\n\n.progress-duration {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 13px;\n  color: var(--text-tertiary);\n}\n\n.progress-percentage {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.progress-bar-container {\n  height: 10px;\n  background: rgba(0, 0, 0, 0.06);\n  border-radius: 5px;\n  overflow: hidden;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);\n  border-radius: 5px;\n  transition: width 0.8s ease-out;\n  position: relative;\n}\n\n.progress-bar-fill.animate::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(255, 255, 255, 0.3) 50%,\n    transparent 100%\n  );\n  animation: shimmer 2s ease-in-out infinite;\n}\n\n.progress-bar-fill.warmup {\n  background: linear-gradient(90deg, #f59e0b 0%, #d97706 100%);\n  width: 2% !important;\n  animation: warmupBar 1.5s ease-in-out infinite;\n}\n\n@keyframes warmupBar {\n  0%, 100% { opacity: 0.6; }\n  50% { opacity: 1; }\n}\n\n.progress-estimate {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 16px;\n  padding: 12px 16px;\n  background: rgba(59, 130, 246, 0.08);\n  border-radius: 10px;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.progress-estimate svg {\n  width: 18px;\n  height: 18px;\n  color: #3b82f6;\n  flex-shrink: 0;\n}\n\n.progress-estimate strong {\n  color: #2563eb;\n  font-weight: 600;\n}\n\n.progress-complete {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 16px;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.08) 100%);\n  border-radius: 10px;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: #059669;\n}\n\n.progress-complete svg {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n.progress-complete-dates {\n  font-weight: 400;\n  opacity: 0.8;\n}\n\n/* Warmup placeholder */\n.warmup-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 40px;\n  background: linear-gradient(135deg, rgba(245, 158, 11, 0.06) 0%, rgba(217, 119, 6, 0.04) 100%);\n  border-radius: 16px;\n  text-align: center;\n}\n\n.warmup-placeholder-icon {\n  width: 64px;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, rgba(245, 158, 11, 0.15) 0%, rgba(217, 119, 6, 0.1) 100%);\n  border-radius: 50%;\n  margin-bottom: 20px;\n  animation: warmupIconPulse 2s ease-in-out infinite;\n}\n\n.warmup-placeholder-icon svg {\n  width: 32px;\n  height: 32px;\n  color: #d97706;\n}\n\n@keyframes warmupIconPulse {\n  0%, 100% { transform: scale(1); opacity: 1; }\n  50% { transform: scale(1.05); opacity: 0.8; }\n}\n\n.warmup-placeholder h4 {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 8px 0;\n}\n\n.warmup-placeholder p {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin: 0;\n  max-width: 400px;\n}\n\n@keyframes shimmer {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n/* Section Styles */\n.dashboard-section {\n  margin-bottom: 32px;\n}\n\n.section-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 20px 0;\n}\n\n.section-title svg {\n  width: 20px;\n  height: 20px;\n  color: var(--accent-orange);\n}\n\n/* Demographics Grid */\n.demographics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n/* Donut Chart */\n.donut-chart-container {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);\n  border: 1px solid rgba(0, 0, 0, 0.04);\n}\n\n.donut-chart-title {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin: 0 0 20px 0;\n  text-align: center;\n}\n\n.donut-chart-wrapper {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n  position: relative;\n}\n\n.donut-chart-wrapper svg {\n  overflow: visible;\n}\n\n.donut-label {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  fill: white;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  pointer-events: none;\n}\n\n.donut-segment.hovered {\n  opacity: 0.85;\n  filter: brightness(1.1);\n}\n\n.donut-tooltip {\n  position: absolute;\n  background: rgba(0, 0, 0, 0.9);\n  color: white;\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 13px;\n  pointer-events: none;\n  transform: translate(-50%, -100%);\n  z-index: 100;\n  white-space: nowrap;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.donut-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 6px solid transparent;\n  border-top-color: rgba(0, 0, 0, 0.9);\n}\n\n.donut-tooltip-label {\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.donut-tooltip-value {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.donut-tooltip-percent {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 12px;\n}\n\n.donut-segment {\n  animation: donutFadeIn 0.5s ease-out forwards;\n  opacity: 0;\n  transition: opacity 0.2s ease, filter 0.2s ease;\n  cursor: pointer;\n}\n\n@keyframes donutFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.donut-legend {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: flex-end;\n}\n\n.donut-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 13px;\n}\n\n.donut-legend-color {\n  width: 10px;\n  height: 10px;\n  border-radius: 3px;\n  flex-shrink: 0;\n}\n\n.donut-legend-label {\n  color: var(--text-secondary);\n  min-width: 50px;\n}\n\n.donut-legend-value {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-variant-numeric: tabular-nums;\n  min-width: 55px;\n  text-align: right;\n}\n\n/* Total Respondents Card */\n.total-respondents-card {\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);\n  border-radius: 16px;\n  padding: 32px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: white;\n}\n\n.total-number {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 48px;\n  font-weight: 700;\n  line-height: 1;\n  margin-bottom: 8px;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n}\n\n.total-label {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  opacity: 0.9;\n  margin-bottom: 12px;\n}\n\n.total-target {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 13px;\n  opacity: 0.75;\n  background: rgba(255, 255, 255, 0.2);\n  padding: 6px 14px;\n  border-radius: 20px;\n}\n\n/* Questions Results */\n.questions-results {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.question-result-card {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);\n  border: 1px solid rgba(0, 0, 0, 0.04);\n  overflow: visible;\n  transition: all 0.25s ease;\n}\n\n.question-result-card:hover {\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n}\n\n.question-result-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 20px 24px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.question-result-header:hover {\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.question-number {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);\n  color: white;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  border-radius: 10px;\n  flex-shrink: 0;\n}\n\n.question-text {\n  flex: 1;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--text-primary);\n  line-height: 1.5;\n}\n\n.expand-icon {\n  width: 20px;\n  height: 20px;\n  color: var(--text-tertiary);\n  transition: transform 0.25s ease;\n  flex-shrink: 0;\n}\n\n.question-result-card.expanded .expand-icon {\n  transform: rotate(180deg);\n}\n\n.question-result-content {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.35s ease;\n}\n\n.question-result-card.expanded .question-result-content {\n  max-height: none;\n  overflow: visible;\n}\n\n.question-charts-row {\n  display: grid;\n  grid-template-columns: 280px 1fr;\n  gap: 32px;\n  padding: 0 24px 24px;\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n  padding-top: 24px;\n  overflow: visible;\n}\n\n@media (max-width: 1400px) {\n  .question-charts-row {\n    grid-template-columns: 200px 1fr;\n    gap: 16px;\n  }\n\n  .stacked-bars {\n    gap: 3px;\n  }\n\n  .stacked-bar-label {\n    font-size: 8px;\n  }\n}\n\n@media (max-width: 1100px) {\n  .question-charts-row {\n    grid-template-columns: 180px 1fr;\n    gap: 12px;\n  }\n\n  .question-pie-wrapper svg {\n    width: 160px;\n    height: 160px;\n  }\n\n  .stacked-bars {\n    gap: 2px;\n  }\n\n  .stacked-bar-label {\n    font-size: 7px;\n  }\n}\n\n@media (max-width: 950px) {\n  .question-charts-row {\n    grid-template-columns: 160px 1fr;\n    gap: 10px;\n  }\n\n  .question-pie-wrapper svg {\n    width: 140px;\n    height: 140px;\n  }\n}\n\n@media (max-width: 850px) {\n  .question-charts-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Pie Chart Section */\n.question-pie-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow: visible;\n}\n\n.question-pie-section.multiple-choice-section {\n  align-items: stretch;\n}\n\n/* When multiple-choice section is present, override grid to give more space */\n.question-charts-row:has(.multiple-choice-section) {\n  grid-template-columns: minmax(280px, 400px) 1fr;\n}\n\n.question-pie-wrapper {\n  position: relative;\n  margin-bottom: 16px;\n}\n\n.pie-chart {\n  overflow: visible;\n}\n\n.pie-segment {\n  animation: pieReveal 0.6s ease-out forwards;\n  transform-origin: center;\n  opacity: 0;\n  transition: opacity 0.2s ease, filter 0.2s ease;\n  cursor: pointer;\n}\n\n.pie-segment.hovered {\n  opacity: 0.85;\n  filter: brightness(1.1);\n}\n\n@keyframes pieReveal {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.pie-label {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  fill: white;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  pointer-events: none;\n}\n\n.question-legend {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n}\n\n.question-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 12px;\n}\n\n.legend-color {\n  width: 10px;\n  height: 10px;\n  border-radius: 3px;\n  flex-shrink: 0;\n}\n\n.legend-text {\n  color: var(--text-secondary);\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.legend-value {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-variant-numeric: tabular-nums;\n  flex-shrink: 0;\n  text-align: right;\n}\n\n/* Creative-test legend — dot + thumbnail + value, compact and left-aligned */\n.question-legend.creative-legend {\n  align-items: flex-start;\n  gap: 10px;\n}\n.question-legend.creative-legend .question-legend-item {\n  width: auto;\n  gap: 12px;\n}\n.legend-thumb {\n  width: 44px;\n  height: 44px;\n  flex-shrink: 0;\n  object-fit: contain;\n  border-radius: 7px;\n  border: 1px solid var(--border-color, #e5e5ee);\n  background: #fff;\n  padding: 2px;\n}\n\n/* Thumbnail inside a chart tooltip (creative-test) — kept small */\n.tooltip-thumb {\n  display: block;\n  width: 64px;\n  height: 64px;\n  object-fit: contain;\n  border-radius: 6px;\n  background: #fff;\n  padding: 2px;\n  margin: 4px auto;\n}\n\n/* Stacked Bar Chart */\n.question-breakdown-section {\n  min-width: 0;\n  overflow: visible;\n}\n\n.breakdown-title {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin: 0 0 16px 0;\n}\n\n.stacked-bar-chart {\n  display: flex;\n  gap: 8px;\n  position: relative;\n  overflow: visible;\n}\n\n.stacked-bar-axis {\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: space-between;\n  height: 180px;\n  padding-right: 8px;\n  flex-shrink: 0;\n}\n\n.stacked-bar-axis span {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 10px;\n  color: var(--text-tertiary);\n  text-align: right;\n}\n\n.stacked-bars {\n  display: flex;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n  align-items: flex-end;\n  justify-content: space-evenly;\n}\n\n.stacked-bar-column {\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.stacked-bar {\n  width: 100%;\n  max-width: 70px;\n  height: 180px;\n  display: flex;\n  flex-direction: column-reverse;\n  border-radius: 6px 6px 0 0;\n  overflow: hidden;\n  background: #f1f3f4;\n}\n\n.stacked-bar-segment {\n  width: 100%;\n  transition: all 0.3s ease;\n  animation: barGrow 0.5s ease-out forwards;\n  transform-origin: bottom;\n  opacity: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.stacked-bar-value {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  color: #fff;\n  line-height: 1;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);\n  pointer-events: none;\n}\n\n@keyframes barGrow {\n  from {\n    transform: scaleY(0);\n    opacity: 0;\n  }\n  to {\n    transform: scaleY(1);\n    opacity: 1;\n  }\n}\n\n.stacked-bar-segment:hover,\n.stacked-bar-segment.hovered {\n  filter: brightness(1.15);\n  cursor: pointer;\n}\n\n.stacked-bar-tooltip {\n  position: absolute;\n  background: rgba(0, 0, 0, 0.9);\n  color: white;\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 12px;\n  pointer-events: none;\n  transform: translate(-50%, -100%);\n  z-index: 100;\n  white-space: nowrap;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.stacked-bar-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 6px solid transparent;\n  border-top-color: rgba(0, 0, 0, 0.9);\n}\n\n.stacked-bar-tooltip-group {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.6);\n  margin-bottom: 2px;\n}\n\n.stacked-bar-tooltip-answer {\n  font-weight: 600;\n  margin-bottom: 2px;\n}\n\n.stacked-bar-tooltip-percent {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.stacked-bar-label {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 9px;\n  font-weight: 500;\n  color: var(--text-tertiary);\n  margin-top: 8px;\n  white-space: nowrap;\n  transform: rotate(-45deg);\n  transform-origin: center center;\n  height: 40px;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .dashboard-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .dashboard-header-right {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .dashboard-title {\n    font-size: 20px;\n  }\n\n  .progress-current {\n    font-size: 24px;\n  }\n\n  .progress-target {\n    font-size: 18px;\n  }\n\n  .total-number {\n    font-size: 36px;\n  }\n\n  .stacked-bar-label {\n    font-size: 8px;\n  }\n}\n\n/* Horizontal Bar Chart for Multiple Choice */\n.horizontal-bar-chart {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 0;\n}\n\n.horizontal-bar-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.horizontal-bar-label {\n  flex: 0 0 120px;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: right;\n}\n\n.multiple-choice-section .horizontal-bar-label {\n  flex: 0 0 140px;\n}\n\n.horizontal-bar-track {\n  flex: 1;\n  height: 28px;\n  min-width: 80px;\n  background: rgba(0, 0, 0, 0.04);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.horizontal-bar-fill {\n  height: 100%;\n  border-radius: 6px;\n  transition: width 0.3s ease, opacity 0.2s ease;\n  cursor: pointer;\n}\n\n.horizontal-bar-fill {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding-right: 6px;\n  min-width: fit-content;\n}\n\n.horizontal-bar-fill:hover,\n.horizontal-bar-fill.hovered {\n  opacity: 0.85;\n}\n\n.horizontal-bar-value-inside {\n  font-family: 'DM Mono', monospace;\n  font-size: 11px;\n  font-weight: 600;\n  color: #fff;\n  white-space: nowrap;\n  text-shadow: 0 1px 2px rgba(0,0,0,0.3);\n}\n\n.horizontal-bar-value {\n  display: none;\n  flex: 0 0 50px;\n  font-family: 'DM Mono', monospace;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-primary);\n  text-align: right;\n}\n\n.horizontal-bar-tooltip {\n  position: absolute;\n  background: rgba(30, 30, 35, 0.95);\n  backdrop-filter: blur(8px);\n  padding: 10px 14px;\n  border-radius: 8px;\n  pointer-events: none;\n  transform: translate(-50%, -100%);\n  z-index: 100;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n  min-width: 140px;\n}\n\n.horizontal-bar-tooltip-label {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n  margin-bottom: 4px;\n}\n\n.horizontal-bar-tooltip-value {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.horizontal-bar-tooltip-percent {\n  font-family: 'DM Mono', monospace;\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n  margin-top: 4px;\n}\n\n.multiple-choice-label {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text-tertiary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 8px;\n  padding: 4px 8px;\n  background: rgba(142, 58, 154, 0.1);\n  border-radius: 4px;\n  display: inline-block;\n}\n\n/* Progress Dates (Start + End) */\n.progress-dates {\n  display: flex;\n  gap: 24px;\n  margin-top: 12px;\n  flex-wrap: wrap;\n}\n\n.progress-date-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.progress-date-item svg {\n  width: 16px;\n  height: 16px;\n  stroke: var(--text-tertiary);\n  flex-shrink: 0;\n}\n\n.progress-date-item strong {\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n/* ===== AI Analysis Button & Panel ===== */\n\n.dashboard-btn-ai {\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);\n  color: #fff;\n  border: none;\n  position: relative;\n  overflow: hidden;\n}\n.dashboard-btn-ai svg {\n  width: 16px; height: 16px;\n}\n.dashboard-btn-ai:hover {\n  filter: brightness(1.08);\n  box-shadow: 0 4px 14px rgba(233, 75, 108, 0.35);\n}\n.dashboard-btn-ai::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(120deg, transparent 30%, rgba(255,255,255,0.18) 50%, transparent 70%);\n  transform: translateX(-100%);\n  transition: transform 0.7s ease;\n}\n.dashboard-btn-ai:hover::before { transform: translateX(100%); }\n\n.ai-panel-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 15, 20, 0.55);\n  backdrop-filter: blur(4px);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: aiOverlayIn 180ms ease;\n}\n@keyframes aiOverlayIn { from { opacity: 0; } to { opacity: 1; } }\n\n.ai-panel {\n  background: #fff;\n  border-radius: 16px;\n  width: min(880px, 92vw);\n  max-height: 88vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.28);\n  overflow: hidden;\n  animation: aiPanelIn 240ms cubic-bezier(0.2, 0.7, 0.2, 1);\n}\n@keyframes aiPanelIn {\n  from { transform: translateY(12px) scale(0.985); opacity: 0; }\n  to   { transform: translateY(0) scale(1); opacity: 1; }\n}\n\n.ai-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 24px;\n  border-bottom: 1px solid #ECEDF2;\n  background: linear-gradient(135deg, rgba(255,107,74,0.06) 0%, rgba(142,58,154,0.06) 100%);\n}\n.ai-panel-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-family: 'DM Sans', sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  color: var(--text-primary);\n}\n.ai-panel-title svg {\n  width: 22px; height: 22px;\n  stroke: url(#ai-grad-stub) #E94B6C;\n}\n.ai-panel-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.ai-panel-lang-switch {\n  display: inline-flex;\n  background: rgba(0, 0, 0, 0.04);\n  border-radius: 8px;\n  padding: 3px;\n  margin-right: 4px;\n}\n.ai-panel-lang-btn {\n  border: none;\n  background: transparent;\n  padding: 5px 10px;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-radius: 6px;\n  min-width: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n.ai-panel-lang-btn:hover:not(:disabled) { color: var(--text-primary); background: rgba(0,0,0,0.04); }\n.ai-panel-lang-btn.active {\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 60%, #8E3A9A 100%);\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(233, 75, 108, 0.25);\n}\n.ai-panel-lang-btn:disabled { opacity: 0.6; cursor: wait; }\n.ai-panel-icon-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 8px;\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ai-panel-icon-btn:hover:not(:disabled) { background: rgba(0,0,0,0.05); color: var(--text-primary); }\n.ai-panel-icon-btn:disabled { opacity: 0.4; cursor: not-allowed; }\n.ai-panel-icon-btn svg { width: 18px; height: 18px; }\n.btn-spinner-sm {\n  display: inline-block;\n  width: 12px; height: 12px;\n  border: 2px solid rgba(255,255,255,0.3);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: aiSpin 0.7s linear infinite;\n}\n@keyframes aiSpin { to { transform: rotate(360deg); } }\n\n.ai-panel-tabs {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  gap: 4px;\n  padding: 0 24px;\n  flex: 0 0 auto;\n  min-height: 52px;\n  border-bottom: 1px solid #ECEDF2;\n  overflow: visible;\n  flex-wrap: wrap;\n}\n.ai-panel-tab {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px;\n  padding: 0 14px;\n  margin: 4px 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  position: relative;\n  transition: color 0.15s, background 0.15s;\n  white-space: nowrap;\n  line-height: 1;\n  border-radius: 8px;\n}\n.ai-panel-tab:focus-visible {\n  box-shadow: 0 0 0 2px rgba(233, 75, 108, 0.3);\n}\n.ai-panel-tab:hover {\n  color: var(--text-primary);\n  background: rgba(0, 0, 0, 0.03);\n}\n.ai-panel-tab.active {\n  color: #fff;\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 60%, #8E3A9A 100%);\n}\n.ai-panel-tab.active:hover { color: #fff; filter: brightness(1.05); }\n.ai-panel-tab-trend.active {\n  background: linear-gradient(135deg, #E94B6C 0%, #8E3A9A 100%);\n}\n\n.ai-panel-content {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n.ai-panel-loading,\n.ai-panel-empty {\n  padding: 48px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  color: var(--text-secondary);\n  font-family: 'DM Sans', sans-serif;\n  font-size: 14px;\n}\n.ai-panel-q-context {\n  font-size: 13px;\n  font-style: italic;\n  color: var(--text-tertiary);\n  margin: 0 0 16px 0;\n  padding: 10px 14px;\n  border-left: 3px solid #FF6B4A;\n  background: rgba(255, 107, 74, 0.04);\n  border-radius: 0 6px 6px 0;\n}\n.ai-panel-footer {\n  margin-top: 24px;\n  padding-top: 12px;\n  border-top: 1px solid #ECEDF2;\n  font-size: 11px;\n  color: var(--text-tertiary);\n  font-family: 'DM Sans', sans-serif;\n}\n\n/* Markdown rendering */\n.ai-md { font-family: 'DM Sans', sans-serif; color: var(--text-primary); line-height: 1.6; font-size: 14px; }\n.ai-md-h2 { font-size: 20px; font-weight: 700; margin: 0 0 12px 0; color: var(--text-primary); }\n.ai-md-h3 { font-size: 16px; font-weight: 700; margin: 18px 0 8px 0; color: var(--text-primary); }\n.ai-md-h4 { font-size: 14px; font-weight: 700; margin: 14px 0 6px 0; color: var(--text-secondary); text-transform: uppercase; letter-spacing: 0.4px; }\n.ai-md-p { margin: 0 0 12px 0; }\n.ai-md-list { margin: 0 0 12px 0; padding-left: 22px; }\n.ai-md-list li { margin-bottom: 6px; }\n.ai-md-hr { border: 0; border-top: 1px solid #ECEDF2; margin: 16px 0; }\n.ai-md code { background: rgba(142, 58, 154, 0.08); color: #8E3A9A; padding: 1px 5px; border-radius: 4px; font-size: 0.9em; font-family: 'JetBrains Mono', monospace; }\n.ai-md strong { color: var(--text-primary); font-weight: 700; }\n.ai-md-table { border-collapse: collapse; width: 100%; margin: 12px 0; font-size: 13px; }\n.ai-md-table th, .ai-md-table td { text-align: left; padding: 8px 12px; border-bottom: 1px solid #ECEDF2; }\n.ai-md-table th { background: #F7F8FB; font-weight: 600; color: var(--text-secondary); }\n.ai-md-table tr:last-child td { border-bottom: none; }\n.ai-md-olist { padding-left: 26px; }\n.ai-md-olist li { padding-left: 4px; }\n\n/* Print-only blocks rendered inside the modal — flat document of all sections */\n.ai-print-only { display: none; }\n.ai-print-section { margin-bottom: 32px; page-break-inside: avoid; }\n.ai-print-section h3.ai-print-section-title {\n  font-size: 13px; text-transform: uppercase; letter-spacing: 1px;\n  color: #888; margin: 0 0 4px 0; font-weight: 600;\n}\n.ai-print-section h2.ai-print-section-name {\n  font-size: 18px; margin: 0 0 12px 0; font-weight: 700;\n}\n\n@media print {\n  /* Hide everything at the body root except the AI panel overlay (rendered via portal) */\n  body > *:not(.ai-panel-overlay) { display: none !important; }\n  /* Strip the modal chrome — render as plain document flow */\n  .ai-panel-overlay {\n    position: static !important;\n    background: transparent !important;\n    backdrop-filter: none !important;\n    inset: auto !important;\n    display: block !important;\n    animation: none !important;\n    height: auto !important;\n    width: 100% !important;\n  }\n  .ai-panel {\n    box-shadow: none !important;\n    border-radius: 0 !important;\n    max-height: none !important;\n    width: 100% !important;\n    overflow: visible !important;\n    animation: none !important;\n    display: block !important;\n  }\n  .ai-panel-header-actions, .ai-panel-tabs, .ai-panel-footer,\n  .ai-panel-loading, .ai-panel-empty { display: none !important; }\n  .ai-panel-content { overflow: visible !important; padding: 0 !important; display: block !important; }\n  .ai-panel-header {\n    background: transparent !important;\n    border-bottom: 2px solid #000 !important;\n    padding: 0 0 12px 0 !important;\n    margin-bottom: 24px !important;\n    display: flex !important;\n  }\n  .ai-print-only { display: block !important; }\n  .ai-print-active-only { display: none !important; }\n  .ai-md, .ai-md p, .ai-md li { font-size: 11pt !important; line-height: 1.45 !important; color: #000 !important; }\n  .ai-md-h2 { font-size: 16pt !important; margin-top: 18px !important; }\n  .ai-md-h3 { font-size: 13pt !important; margin-top: 14px !important; }\n  .ai-md-h4 { font-size: 11pt !important; }\n  .ai-md-table { font-size: 10pt !important; }\n  .ai-panel-q-context { background: #f6f6f6 !important; color: #333 !important; }\n  @page { margin: 18mm 16mm; }\n}\n\n/* ---------------------------------------------------------------------------\n   Audience settings — the brief the research was ordered with, sitting between\n   the progress bar and the demographics that actually answered. Collapsed by\n   default so it never competes with the results.\n   --------------------------------------------------------------------------- */\n.audience-brief {\n  background: #fff;\n  border: 1px solid #edeff2;\n  border-radius: 14px;\n  margin-bottom: 24px;\n  overflow: hidden;\n}\n\n.audience-brief-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n}\n\n.audience-brief-header:hover { background: #fafbfc; }\n\n.audience-brief-header > svg:first-child {\n  width: 18px;\n  height: 18px;\n  color: var(--text-tertiary, #9aa0a6);\n  flex-shrink: 0;\n}\n\n.audience-brief-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1a1a1a;\n  flex-shrink: 0;\n}\n\n/* The one-line recap keeps the collapsed state informative. */\n.audience-brief-summary {\n  font-size: 13px;\n  color: #6c757d;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.audience-brief-chevron {\n  width: 18px;\n  height: 18px;\n  color: #9aa0a6;\n  flex-shrink: 0;\n  transition: transform 0.25s ease;\n}\n\n.audience-brief.expanded .audience-brief-chevron { transform: rotate(180deg); }\n\n.audience-brief-body {\n  padding: 4px 20px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  border-top: 1px solid #f1f3f5;\n}\n\n.audience-brief-row {\n  display: grid;\n  grid-template-columns: 150px minmax(0, 1fr);\n  gap: 14px;\n  align-items: baseline;\n}\n\n@media (max-width: 720px) {\n  .audience-brief-row { grid-template-columns: 1fr; gap: 6px; }\n}\n\n.audience-brief-label {\n  font-size: 13px;\n  color: #6c757d;\n  padding-top: 4px;\n}\n\n.audience-brief-values {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.audience-brief-chip {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: #f4f6f8;\n  color: #1a1a1a;\n  font-size: 12.5px;\n  line-height: 1.35;\n}\n\n/* The dashboard sits in a panel that can get narrow: a long research name\n   is one unbreakable token, and the action row must wrap rather than\n   widen the page. */\n.research-dashboard { min-width: 0; }\n.dashboard-header { flex-wrap: wrap; gap: 12px; min-width: 0; }\n.dashboard-header-left { min-width: 0; }\n.dashboard-title { overflow-wrap: anywhere; min-width: 0; }\n.dashboard-header-right { flex-wrap: wrap; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
